import React from "react";
import {
    getMatchInfo,
    GetMatchScores,
    GetTennisMatchStatus,
    renderBasketballScores,
    renderCricketScores,
    renderTennisScores,
    linkName,
    seoBaseOpenMatchDetailUrl,
    extractScores, calculateWinner, getTeamLogos,
    ToLowerText
} from "../../../utils/generalLiveCenter";
import { MatchOptions } from "../../../utils/matchOptions";
import TeamRow from "./TeamRow";
import MatchStatus from "./MatchStatus";

const CricketMatchBox = ({ league, difference, displayDate, dictionary, baseURL, websiteBaseUrl, dataPath, dataClient, sport }) => {
    const handleClick = (match) => {
        if (dataClient) {
            window.location.href = websiteBaseUrl
                ? `${websiteBaseUrl}/${dataPath}/match-detail/${linkName(match?.competitors?.htn)}-vs-${linkName(match?.competitors?.atn)}/${match?.id}/${seoBaseOpenMatchDetailUrl(sport, match, "info")}`
                : `/${dataPath}/match-detail/${linkName(match?.competitors?.htn)}-vs-${linkName(match?.competitors?.atn)}/${match?.id}/${seoBaseOpenMatchDetailUrl(sport, match, "info")}`;
        }
    };


    return (
        <>
            {league?.matches.map((match) => {
                const tennisScore = [
                    "1st set",
                    "2nd set",
                    "3rd set",
                    "4th set",
                    "5th set",
                ]?.includes(GetTennisMatchStatus(match?.st, match?.cp, match))
                    ? match?.scores?.find((t) => ToLowerText(t?.ty) === "cfs")
                    : match?.scores?.find((t) => ToLowerText(t?.ty) === "finished");
                const homeScore = tennisScore?.nm?.split(":")?.[0]?.trim();
                const awayScore = tennisScore?.nm?.split(":")?.[1]?.trim();
                const live = MatchOptions?.basketballLiveStatuses?.includes(match?.st) || match?.bs === "Live";
                const { statusText, statusClass, liveStatusText } = getMatchInfo(match, live, sport);

                const scores = Array.from({ length: 4 }, (_, i) => extractScores(match, i + 1));
                const winner = calculateWinner(scores);

                const { home: homeLogo, away: awayLogo } = getTeamLogos(sport, match);

                return (
                    <div key={match?.id} className={`leg_row_basketball ${sport === "cricket" ? "cricket_row" : ""} ${live && "live"}`} onClick={() => handleClick(match)}>
                        <MatchStatus match={match} sport={sport} live={live} statusText={statusText} statusClass={statusClass} liveStatusText={liveStatusText} dictionary={dictionary} difference={difference} displayDate={displayDate} />

                        <div className="row_inner">
                            <div className="match_info">
                                <div className="basketball_player">
                                    <TeamRow teamName={match?.competitors?.htn} teamLogo={homeLogo} isWinner={winner === "home" || homeScore > awayScore ? "bold" : null} isLive={live} sport={sport} baseURL={baseURL} match={match} isHome />
                                    <TeamRow teamName={match?.competitors?.atn} teamLogo={awayLogo} isWinner={winner === "away" || homeScore < awayScore ? "bold" : null} isLive={live} sport={sport} baseURL={baseURL} match={match} />
                                </div>
                            </div>

                            <div className="score_wrp">
                                {(sport === "basketball" || sport === "icehockey") && renderBasketballScores(scores, winner, live, match?.cfs, match?.ft)}
                                {sport === "tennis" && renderTennisScores(GetMatchScores(match?.scores, GetTennisMatchStatus(match?.st, match?.cp, match)), homeScore, awayScore, live)}
                                {sport === "cricket" && renderCricketScores(match)}
                            </div>
                        </div>
                        {sport === "cricket" && match?.st !== "Not Started" && (
                            <div className="match_info_tft">
                                {match?.com ? <span className="lft">{match?.com}</span> : ""}
                                <span className="rgt">
                                    {dictionary?.stadium || "Stadium"} : {match?.stad?.nm},{" "}
                                    {match?.stad?.cty}
                                </span>
                            </div>
                        )}
                    </div>
                );
            })}
        </>
    );
};

export default CricketMatchBox;
